import { INTERNAL_LINKS } from '../../enum';

export const NAVIGATE_TO = 'NAVIGATE_TO';
export const UPDATE_BASENAME = 'UPDATE_BASENAME';

export const emitNavigateTo = (pathname = INTERNAL_LINKS.HOME, useAboslute = false) => {
  return { type: NAVIGATE_TO, data: { pathname, useAboslute } };
};
